import { render, staticRenderFns } from "./Pill.vue?vue&type=template&id=31717be6&scoped=true"
import script from "./Pill.ts?vue&type=script&lang=ts&external"
export * from "./Pill.ts?vue&type=script&lang=ts&external"
import style0 from "./Pill.scss?vue&type=style&index=0&id=31717be6&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31717be6",
  null
  
)

export default component.exports